import { render } from "./MemberProject.vue?vue&type=template&id=8606dd82"
import script from "./MemberProject.vue?vue&type=script&lang=js"
export * from "./MemberProject.vue?vue&type=script&lang=js"

import "./MemberProject.vue?vue&type=style&index=0&id=8606dd82&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__